import React from 'react';
import SATextInput from './SATextInput';
import { Row, Col } from 'react-bootstrap';

export default function AdvisorName(props) {
    const register = props?.register;
    const errors = props?.errors;
 
    return (
        <React.Fragment>
            <Row>
                <Col lg={4}>
                    <SATextInput
                        register={register}
                        htmlFor={props.firstNameHtmlFor}
                        name={props.nameForFirstName}
                        label={"First Name:"}
                        isStrong={true}
                        requiredText={"First Name is required!"}
                        type={"text"}
                        placeholder={"First Name (required)"}
                        errors={errors}
                        id={props.firstNameId}
                        errMsg={props.firstNameErrMsg}
                        maxLength={32}
                        requiredObj={{ required: "First Name is required!",
                        pattern: {
                            value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid First Name!"
                        } }} 
                    />
                </Col>
                <Col lg={4}>
                    <SATextInput
                        register={register}
                        htmlFor={props.lastNameHtmlFor}
                        name={props.nameForLastName}
                        label={"Last Name:"}
                        isStrong={true}
                        requiredText={"Last Name is required!"}
                        type={"text"}
                        placeholder={"Last Name (required)"}
                        errors={errors}
                        id={props.lastNameId}
                        maxLength={32}
                        errMsg={props.lastNameErrMsg}
                        requiredObj={{ required: "Last Name is required!",  pattern: {
                            value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid Last Name!"
                        }}}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}